import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
// CODEX_PROMPT_84 : tagline du splash via i18n. AppLoader n'a pas de prop
// `language` (rendu sans contexte de langue dans App.js) : on lit la valeur FR.
import translations from '../data/translations';

const MIN_DISPLAY_MS = 800;
const FADE_OUT_MS = 400;

export default function AppLoader({ isAppReady }) {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (!isAppReady) return;

    const minDisplayTimer = setTimeout(() => {
      setIsExiting(true);
    }, MIN_DISPLAY_MS);

    return () => clearTimeout(minDisplayTimer);
  }, [isAppReady]);

  return (
    <AnimatePresence>
      {!isExiting && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: FADE_OUT_MS / 1000, ease: 'easeInOut' }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center"
          style={{
            background: 'linear-gradient(135deg, #FFF7F5 0%, #FFF1EC 50%, #FFEDE8 100%)',
          }}
        >
          {/* Tête de Bongo — animation d'entrée */}
          <motion.div
            initial={{ scale: 0.5, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.34, 1.56, 0.64, 1] }}
            className="flex flex-col items-center gap-5"
          >
            {/* Tête de Bongo */}
            <div
              className="w-28 h-28 rounded-3xl overflow-hidden"
              style={{
                boxShadow: '0 12px 40px rgba(232,132,92,0.35)',
              }}
            >
              <img
                src="/assets/bongo/head/bongo-head.png"
                alt="Bongo"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Nom */}
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.4 }}
              className="text-center"
            >
              <h1
                className="text-2xl font-extrabold tracking-tight"
                style={{
                  // CODEX_PROMPT_84 : degrade peche -> terracotta (fallback color #40302A)
                  color: '#40302A',
                  backgroundImage: 'linear-gradient(135deg, #FFB89A 0%, #D26A4E 100%)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                ColoBongo
              </h1>
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.5 }}
                transition={{ delay: 0.5, duration: 0.3 }}
                className="text-xs mt-1"
                style={{ color: '#907870' }}
              >
                {translations.fr.splashTagline}
              </motion.p>
            </motion.div>
          </motion.div>

          {/* Spinner subtil en bas */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.3 }}
            className="mt-8 flex flex-col items-center gap-2"
          >
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 1.2, repeat: Infinity, ease: 'linear' }}
              className="w-5 h-5 rounded-full border-2 border-transparent"
              style={{
                borderTopColor: '#E8845C',
                borderRightColor: 'rgba(232,132,92,0.3)',
              }}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
